import { useDispatch } from 'react-redux';
import { Models, RematchDispatch } from '@rematch/core';

export function useRematchDispatch<RootModel extends Models<RootModel>>() {
  return useDispatch<RematchDispatch<RootModel>>();
}
